module.exports = __webpack_public_path__ + "static/media/caution_light@2x.c08c70ac.png";